import AbsModule from '../common/AbsModule';
import { lnbMarkup } from '../common/LnbCommon';
import { getIndex } from '../common/domUtil';
import { ssoUrlExternal } from '../common/url';

let test;
class Lnb extends AbsModule {
    constructor(_config) {
        super(_config);
        this.disabled = !Array.isArray(_config.lnbData) || _config.lnbData.length === 0;
        this.onScrollCallback = () => {}
    }

    startSetting() {
        if (this.disabled) return;

        const lnb = document.querySelector('.ncc-lnb');
        const lnbItems = document.querySelectorAll('.ncc-lnb .ncc-lnb-item');
        const lnbSubItems = document.querySelectorAll('.ncc-lnb .ncc-lnb-item .ncc-lnb-item__sub li');
        const callbackItems = document.querySelectorAll('#nc-cnb .ncc-lnb [data-callback]');
        const externalSsoItems = document.querySelectorAll('#nc-cnb .ncc-lnb [data-type="external"][data-sso="true"');
        const {
            active = {},
            lnbCallbackMap
        } = this.moduleData;
        const isMain = !active.d1 && !active.d2;

        if (isMain) {
            lnb?.classList?.add('ncc-lnb-type--main');
        }

        // onClick 콜백 실행
        callbackItems?.forEach(item => {
            item?.addEventListener('click', e => {
                e.preventDefault();

                const target = e.currentTarget;
                const callbackKey = target?.dataset?.callback;
                const callback = lnbCallbackMap?.get(callbackKey);
                
                // callback 실행
                if(typeof callback === 'function') {
                    callback(e);
                }

                return false;
            });
        });

        // 외부 창 + ssourl일 때
        externalSsoItems?.forEach(item => {
            item?.addEventListener('click', async(e) => {
                e.preventDefault();

                const url = e?.currentTarget?.href;
                await ssoUrlExternal(url);

                return false;
            });
        });


        // menu items
        if(lnbItems.length > 0) {
            lnbItems.forEach(item => {
                item?.addEventListener('mouseenter', e => {
                    if (isMain) {
                        lnb?.classList?.add('ncc-lnb-type--main-over');
                    }
                    const target = e.currentTarget;
                    const lnbList = target.parentNode;
                    const prevActiveItem = lnbList.querySelector(`li.m${active.d1}`);
                    const itemIndex = getIndex(target);

                    prevActiveItem?.classList?.remove('is-active');
                    target?.classList?.add('is-over');
    
    
                    return false;
                });

                item?.addEventListener('mouseleave', e => {
                    if (isMain) {
                        lnb?.classList?.remove('ncc-lnb-type--main-over');
                    }
                    const target = e.currentTarget;
                    const lnbList = target.parentNode;
                    const currentActiveItem = lnbList?.querySelector(`li.m${active.d1}`);

                    target?.classList?.remove('is-over');
                    currentActiveItem?.classList?.add('is-active');

                    return false;
                });
            });
        }

        // sub items
        if(lnbSubItems.length > 0) {
            lnbSubItems.forEach(subItem => {
                subItem?.addEventListener('mouseenter', e => {
                    const target = e.currentTarget;
                    const lnbItem = target?.parentNode?.parentNode;
                    const lnbList = lnbItem?.parentNode;
                    const activeTarget = lnbList.querySelector(`li.m${active.d1} .ncc-lnb-item__sub li.s${active.d2}`);
                    const lnbItemIndex = getIndex(lnbItem);
                    const subItemIndex = getIndex(target);

                    activeTarget?.classList?.remove('is-active');
                    target?.classList?.add('is-active');

                    return false;
                });

                subItem?.addEventListener('mouseleave', e => {
                    const target = e.currentTarget;
                    const lnbItem = target?.parentNode?.parentNode;
                    const lnbList = lnbItem?.parentNode;
                    const activeTarget = lnbList.querySelector(`li.m${active.d1} .ncc-lnb-item__sub li.s${active.d2}`);

                    target?.classList?.remove('is-active');
                    activeTarget?.classList?.add('is-active');

    
                });
            });
        }

    }

    
    makeMarkup() {
        const { lnbData, active } = this.moduleData || {};

        return `
        <nav class="ncc-lnb">
            ${lnbMarkup({
                lnbData, 
                isSub: false, 
                active
            })}
        </nav>`;
    }
}

export default Lnb;